module.exports = __webpack_public_path__ + "img/crystal.4b14459.jpg";